window.initReportTableForm = function() {
  $('.js-show-in-summary-table').on('change', function(){
    if($(this).is(':checked')){
      $(this).closest('.field').find('.input').prop('disabled', false);
    } else {
      $(this).closest('.field').find('.input').prop('disabled', true);
    }
  })
  initFormSort();
}